import React, { useState } from "react";
import EastOutlinedIcon from "@mui/icons-material/EastOutlined";
import WestOutlinedIcon from "@mui/icons-material/WestOutlined";
import style from "./Slider.module.scss";

const Slider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const data = ["/img/banner1.jpg", "/img/banner4.jpg", "/img/banner2.jpg"];

  const prevSlide = () => {
    setCurrentSlide(currentSlide === 0 ? 2 : (prev) => prev - 1);
  };

  const nextSlide = () => {
    setCurrentSlide(currentSlide === 2 ? 0 : (prev) => prev + 1);
  };

  return (
    <div className={style.slider}>
      <div
        className={style.container}
        style={{ transform: `translateX(-${currentSlide * 100}vw)` }}
      >
        <img src={data[0]} alt="" />
        <img src={data[1]} alt="" />
        <img src={data[2]} alt="" />
      </div>
      <div className={style.icons}>
        <div className={style.icon} onClick={prevSlide}>
          <WestOutlinedIcon />
        </div>
        <div className={style.icon} onClick={nextSlide}>
          <EastOutlinedIcon />
        </div>
      </div>
    </div>
  );
};

export default Slider;
